let keys = "";
if (
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1" ||
  window.location.hostname === ""
) {
  keys = "http://localhost:3002";
} else if (window.location.hostname === "lp.goola.run") {
  keys = "https://affiliate-api.goola.run";
} else if (window.location.hostname === "d2sygywnmd0lrr.cloudfront.net") {
  keys = "https://staging.gapi-affiliate.goola.run";
}

export default keys;
